import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTRPCAPI } from '../../trpc/trpc';
import { useRealtimeEvent } from '../realtime/useRealtimeEvent';

/** The socket invalidates only fymAPI tags (spec §15.2). This hook refreshes the tRPC checklist. */
export function useOnboardingRealtime(): void {
  const trpcAPI = useTRPCAPI();
  const queryClient = useQueryClient();
  const refresh = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: trpcAPI.onboarding.state.queryKey() }).catch(console.error);
  }, [queryClient, trpcAPI]);
  useRealtimeEvent('catalog.song.updated', refresh);
  useRealtimeEvent('kit.asset.updated', refresh);
  useRealtimeEvent('promo.channel.synced', refresh);
  useRealtimeEvent('promo.post.updated', refresh);
  useRealtimeEvent('promo.posts.changed', refresh);
  useRealtimeEvent('artistPortal.synced', refresh);
}
